<template>
  <div v-if="value" class="dialog__wrapper" @click.self="handleWrapperClick">
    <div class="dialog">
      <!-- <div class="dialog_left">
        <slot name="dialog_codelogin"></slot>
      </div> -->
      <div class="dialog_all">
        <div class="dialog__header">
          <slot name="title">
            <span class="dialog__title">{{ title }}</span>
          </slot>
          <button type="button" class="dialog__headerbtn" @click="handleClose">
            <i class="dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
        <div class="dialog__body">
          <slot name="body">123213</slot>
        </div>
        <div class="dialog__footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",

  props: {
    value: {},
    title: {},
  },
  data() {
    return {
      visible: true,
      // key: 0,
      // a:0
    };
  },
  mounted() {
    // console.log("🚀 ~ mounted")
    //  this.$nextTick(() => {
    // document.body.style.overflow = 'hidden'
    // });
  },
  watch: {
    value(val) {
      if (val) {
        this.handleOpen();
      } else {
        this.handleClose();
      }
    },
  },
  methods: {
    handleOpen() {
      // document.body.style.overflow = 'hidden'
      // debugger
      //   let body = document.documentElement
      //   let scrollWidth = window.innerWidth - body.clientWidth
      //   body.style.overflow = "hidden"
      // body.style.paddingRight = scrollWidth+'px'
      this.$emit("open");
    },
    handleWrapperClick() {
      // this.handleClose()
      // this.$store.commit('user/DIALOG_VISIBLE')
    },
    handleClose() {
      // document.body.style.overflow = ''
      this.$emit("close", false);
      this.$emit("input", false);
      //    let body = document.documentElement;
      //       body.style.overflow = '';
      //       body.style.paddingRight = '';
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0046b9;
  border-color: #0046b9;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0046b9;
}
::v-deep .el-checkbox__inner {
  width: 16px;
  height: 16px;
  &:hover {
    border-color: #0046b9;
  }
  &::after {
    height: 8px;
    left: 5px;
  }
}
::v-deep .el-checkbox__label {
  padding: 0 0 0 8px;
}
</style>

<style lang="scss" scoped>
// 主字体颜色
$font-lord: #333333;
// 次字体颜色
$font-bout: #777777;
// N次字体颜色
$font-minbout: #aaa;
// 描边颜色
$stroke-color-index1: #e0e0e0;
$stroke-color-index2: #f0f0f0;
// 按钮描边
$btn-colorBR: #dddddd;
// 选中动态颜色
$atv-colorBR: #0046b9;
// 字体大小
$font-24: 24px;
$font-18: 18px;
$font-16: 16px;
$font-14: 14px;
$font-13: 13px;
// .dialog_all {
//   box-sizing: border-box;
//   width: 344px;
// }
.dialog__wrapper {
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.2);
}
.dialog {
  position: relative;
  margin: 0 auto 50px;
  background: #fff;

  margin-top: 15vh;
  width: 400px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 0 20px;
}

.dialog__header {
  padding: 20px 0;

  text-align: center;
  border-bottom: 1px solid #e6e6e6;
  font-family: PingFangSC-Medium, PingFang SC;
  box-sizing: border-box;
}
.dialog__title {
  font-weight: 500;
  font-size: 16px;
  // color: #333333;
  line-height: 22px;
}
.el-icon-close {
  color: $font-bout;
}

.dialog__headerbtn {
  position: absolute;
  top: 16px;
  right: 24px;
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
}

.dialog__body {
  padding: 25px;
}
</style>
